import { put, call } from 'redux-saga/effects';
import { map } from 'lodash';
import { actionSuccess, actionFailed } from 'shared/actions';
import axios from 'axios';
import { GET_LANGUAGES_SUCCESS, GET_LANGUAGES_FAILED } from './constants';

function languagesApi() {
	return axios.request({
		url: `${process.env.REACT_APP_API_URL}ref-data/language`,
		method: 'GET'
	});
}

export function* languagesSaga() {
	try {
		const {
			data: { data }
		} = yield call(languagesApi);
		const customData = map(data, ({ code, languageName }) => {
			return {
				key: code,
				text: languageName,
				value: code
			};
		});

		yield put(actionSuccess(GET_LANGUAGES_SUCCESS, customData));
	} catch (error) {
		yield put(actionFailed(GET_LANGUAGES_FAILED, []));
	}
}
